module.exports = __webpack_public_path__ + "assets/img/settingsvg.cc0529a0.svg";